import { useState } from 'react'
import { Typography, AppBar, IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import { BackButton } from '$common/buttons'
import { DoneIcon } from '$common/icons/done'
import { CircularLoading } from '$common/loading/circular-loading'
import { nothing } from '$func/utils'
import { PageToolbar } from '$common/app-bar/common/page-toolbar'

const TitleTypography = styled(Typography)`
  margin-right: 7px;
  flex-grow: 1;
`

const StyledDoneIcon = styled(DoneIcon)(({ theme }) => ({
  transition: theme.transitions.create('opacity'),
}))

interface Prop {
  title: string
  confirmDisabled?: boolean
  onBack: () => any
  onConfirm: () => any | Promise<any>
}

export function AppBarBackTitleConfirm({
  title,
  confirmDisabled,
  onConfirm,
  onBack,
}: Prop) {
  const [loading, setLoading] = useState(false)

  const handleConfirm = () => {
    if (loading) return
    setLoading(true)
    onConfirm()
      .catch(nothing)
      .finally(() => setLoading(false))
  }

  return (
    <AppBar>
      <PageToolbar>
        <BackButton onClick={onBack} />
        <TitleTypography color="neutral900" variant="subtitle1">
          {title}
        </TitleTypography>

        {loading ? (
          <CircularLoading size={20} />
        ) : (
          <IconButton onClick={handleConfirm} disabled={confirmDisabled}>
            <StyledDoneIcon
              sx={{ color: 'neutral900' }}
              style={{
                opacity: confirmDisabled ? 0.4 : 1,
              }}
            />
          </IconButton>
        )}
      </PageToolbar>
    </AppBar>
  )
}

AppBarBackTitleConfirm.defaultProps = {
  confirmDisabled: false,
}
